import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { getCartItemSubtotal } from '@pedix-workspace/orders';
import { CartItem } from '@pedix-workspace/utils';
import { CurrencyFormatPipe } from '@pedix-workspace/pedixapp-shared-pipes';
import { RouterLink } from '@angular/router';
import { ButtonComponent } from '@pedix-workspace/angular-ui-button';

import { TranslocoDirective } from '@jsverse/transloco';
import { AppCartItemsService } from '../../../app-cart-items.service';

@Component({
  selector: 'app-show-order',
  templateUrl: './show-order.component.html',
  styleUrls: ['./show-order.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslocoDirective, ButtonComponent, RouterLink, CurrencyFormatPipe],
})
export class ShowOrderComponent {
  private appCartItemsService = inject(AppCartItemsService);

  readonly cartItems = computed(() => this.appCartItemsService.cartItems());
  readonly showBlock = computed(() => this.cartItems().length > 0);
  readonly amount = computed(() => this.calculateAmount(this.cartItems()));

  private calculateAmount(cartItems: CartItem[]) {
    return cartItems.reduce(
      (amount, cartItem) => amount + getCartItemSubtotal(cartItem, { usePriceDiscount: true }),
      0,
    );
  }
}
